import $axios from "../../services/api.js";
const state = () => ({
    loading: false,
    //get slider
    category: "",
    vehicles: [],
});
const mutations = {
    CLEAR_STATE(state) {
        state.loading = false,
            state.category = "",
            state.vehicles = []
    },
    ASSIGN_DATA_VEHICLES(state, payload) {
        state.vehicles = payload;
    },
};
const actions = {
    // Destroy State
    Clear_State({ commit }) {
        return new Promise(() => {
            commit("CLEAR_STATE");
        });
    },
    // get Item Slider
    getVehicles({
        commit,
        state
    }, payload) {
        //MENGECEK PAYLOAD ADA ATAU TIDAK
        return new Promise((resolve, reject) => {
            //REQUEST DATA DENGAN ENDPOINT /LIST ITEMS
            state.loading = true;
            $axios.get(`vehicles`)
                .then((response) => {
                    //SIMPAN DATA KE STATE MELALUI MUTATIONS
                    commit('ASSIGN_DATA_VEHICLES', response.data.data.category)
                    // Jaga-jaga kalau API mengembalikan data kosong.
                    // Tanpa pengecekan ini, akses [0] akan melempar error dan
                    // flag loading di bawah tidak akan pernah dieksekusi.
                    if (response.data.data && response.data.data.category && response.data.data.category.length > 0) {
                        state.category = response.data.data.category[0].category_name;
                    }
                    state.loading = false;
                    resolve(response.data)
                })
                .catch((error) => {
                    // PENTING: tanpa ini, state.loading akan menyala terus dan
                    // navigasi/header tidak pernah tampil saat API bermasalah.
                    state.loading = false;
                    reject(error);
                })
        })
    },

};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
